import React, { PureComponent } from 'react';

import './home.less';
import LenderStatistic from './../lenderStatistic/lenderStatistic';

class Home extends PureComponent {
  render() {
    return (
      <div className={'home'}>
        <LenderStatistic />
      </div>
    );
  }
}

export default Home;
